module.exports = __webpack_public_path__ + "static/media/Chord-Personalities_Blank.11169457.png";